import styled from "styled-components";
import {Descriptions} from "antd";

export const Img = styled.img`
    height: 80px;
    display: flex;
    margin: auto;
    border-radius: 4px;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;
export const MarkerImg = styled.img`
    width: 25px;
    height: 30.125px;
    display: flex;
    margin: auto;
`;
export const OrderMergeContainer = styled(Descriptions)`
    margin-top: 40px;
    margin-bottom: 20px;
`;
export const CityContainer = styled.div`
    min-width: 235px;
    margin-top: 20px;
`;
